(function () {
    'use strict';

    /**
     * This directive is a simple utility function that evals an expression (effectively hiding the container to which it's applied)
     * when user clicks elsewhere in the document.
     * 
     * The floatingContainer directive should be applied on an ngIfed element only. Do not apply on ngShowed elements,
     * because we deregister the click handler on destroy so we need that $scope destruction that ngIf provides.
     */
    angular.module('GorillaBoy.directives')
    .directive('floatingContainer', ['$timeout', '$document', '$rootScope', 'SignalProvider', function ($timeout, $document, $rootScope, SignalProvider) {
        return {
            restrict: 'A',
            link: function ($scope, $element, $attrs) {
                var rootScopeDeregistererFn = null;
                function registerEvtHandlers() {
                    rootScopeDeregistererFn = $rootScope.$on(SignalProvider.CustomClickEvent, fileOrFolderSelectHanlder);
                    $document.on('click', docClickHandler);
                }
                
                function deregisterEvtHandlers() {
                    if (rootScopeDeregistererFn) {
                        rootScopeDeregistererFn();
                        rootScopeDeregistererFn = null;
                    }
                    $document.off('click', docClickHandler);
                }
                
                function fileOrFolderSelectHanlder() {
                    $scope.$evalAsync($attrs.floatingContainer);
                }

                function docClickHandler(evt) {
                    var elementDom = $element.get(0);
                    //eval the expression when user clicks elsewhere or when the target that user clicked on is not present
                    //in the container and it's a valid live DOM element
                    if (!jQuery.contains(elementDom, evt.target) && 
                            elementDom !== evt.target &&
                            jQuery(evt.target).parents('html').length > 0) {
                        $scope.$evalAsync($attrs.floatingContainer);
                    }
                }

                //The reason we need to add this registration call in a $timeout is because
                //It would fire immediately in the same click that opened the container
                $timeout(function() {
                    registerEvtHandlers();
                }, 0, false); //false because we don't need a $digest run

                //Very important to deregister the click handler on $destroy
                $scope.$on("$destroy", deregisterEvtHandlers);
            }
        };
    }]);

}());